module.exports = __webpack_public_path__ + "fonts/DINRoundPro.ttf?056ff89a";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/DINRoundPro.ttf
// module id = 850
// module chunks = 0 1 2 3 4 5